import { Component } from "@angular/core";

@Component({
    selector: "m-title",
    template: `
        <h2>
            <ng-content></ng-content>
        </h2>
    `,
    styles: [
        `
            h2 {
                line-height: 31px;
                color: var(--primary-color);
                font-size: 20px !important;
            }
        `
    ]
})
export class MiproModuleTitleComponent {}
